import axios from '../utils/axios/index.js';

// member_id - Member’s ID
// site - site belonging to the member
export const vipInfoApi = (params) => {
  return axios.post(`api/member/vip/info`, params )
}


// WEBPACK FOOTER //
// ./src/api/vip.js